export default {
  data() {
    return {};
  },
  props: {
    isHost: {
      type: Boolean,
      default: true
    },
    rtilCode: {
      type: [Number, String],
      default: ''
    },
    userInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    liveInfo: {
      type: Object,
      default: () => {
        return {};
      }
    },
    talkBackInfo: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    returnLiveTips() {
      let _str = '';
      if (this.talkBackInfo[this.rtilCode]) {
        _str = this.$t('commonSetting.hostLazyOnTips');
      } else {
        _str = this.$t('commonSetting.hostLazyDisableTips');
      }
      return _str;
    }
  },
  methods: {
    setTalkback() {
      this.$emit('callback', {
        type: 'setTalback'
      });
    }
  }
};